import * as React from 'react';

import TextField from './TextField';
import { isValidValue } from './validateField';

var FloatField = function FloatField(_ref) {
    var dataKey = _ref.dataKey,
        dataValue = _ref.dataValue,
        displayName = _ref.displayName,
        description = _ref.description,
        error = _ref.error,
        onChange = _ref.onChange,
        onRemove = _ref.onRemove,
        type = _ref.type;
    return React.createElement(TextField, {
        dataKey: dataKey,
        dataValue: dataValue,
        description: description,
        displayName: displayName,
        error: error,
        onChange: function (_onChange) {
            function onChange(_x, _x2) {
                return _onChange.apply(this, arguments);
            }

            onChange.toString = function () {
                return _onChange.toString();
            };

            return onChange;
        }(function (key, value) {
            if (isValidValue(type, value, { allowTrailingPeriod: true })) {
                onChange(key, value);
            }
        }),
        onRemove: onRemove
    });
};

FloatField.propTypes = {
    dataKey: PropTypes.string.isRequired,
    dataValue: function dataValue() {
        return (typeof bpfrpt_proptype_FieldValue === 'function' ? bpfrpt_proptype_FieldValue : PropTypes.shape(bpfrpt_proptype_FieldValue)).apply(this, arguments);
    },
    description: PropTypes.string,
    displayName: PropTypes.string.isRequired,
    error: PropTypes.node,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired
};
export default FloatField;
import { bpfrpt_proptype_FieldValue } from '../flowTypes';
import PropTypes from 'prop-types';